import { useContext, useLayoutEffect } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { SocialContext } from '../contexts/socialContext';
import { StateContext } from '../contexts/stateContext';
import { applyDesignTheme, findDesignForUseravatarId } from './utilsDesign';
import { findDesignForPentaId } from './utilsPenta';

export function DesignThemeSync() {
  const { useravatarId, pentaId } = useParams();
  const location = useLocation();
  const context = { ...useContext(SocialContext), ...useContext(StateContext) };

  useLayoutEffect(() => {
    if (location.pathname.startsWith('/p/')) {
      const design = findDesignForPentaId(pentaId, context);
      applyDesignTheme(design);
      return;
    }

    if (location.pathname.startsWith('/u/') || location.pathname.startsWith('/i/')) {
      const design = findDesignForUseravatarId(useravatarId, context);
      applyDesignTheme(design);
    }
  }, [
    useravatarId,
    pentaId,
    location.pathname,
    context.cachedUsers,
    context.avatars,
    context.pentas,
    context.followings,
    context.followers,
    context.state?.showHistory,
    context.me?.avatar?.design?.type,
    context.me?.user?.token,
  ]);

  return null;
}
